import { render, staticRenderFns } from "./transfer-data.vue?vue&type=template&id=0fdc736b&scoped=true"
import script from "./transfer-data.vue?vue&type=script&lang=js"
export * from "./transfer-data.vue?vue&type=script&lang=js"
import style0 from "./transfer-data.vue?vue&type=style&index=0&id=0fdc736b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc736b",
  null
  
)

export default component.exports